import { makeStyles, Theme } from '@material-ui/core'

export default makeStyles<Theme>({
  root: {}
})
